import React from "react";
import FormCustomer from "../../Components/FormCustomer/FormCustomer";
import { useParams } from "react-router-dom";


const PageCliente: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  return (
    <div className="d-flex flex-column container-fluid">
      <FormCustomer />
    </div>
  );
};

export default PageCliente;